module.exports = __webpack_public_path__ + "static/media/ZOND_NIR-1.ba8afdc5.png";